import {
  Badge,
  Divider,
  Heading,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import { CheckCard, Pill, Reveal, Section, TEAL_DARK } from "./utils";
import { excuse, items } from "./data";

const ForYou = () => (
  <Section bg="white" id="for-you">
    <VStack gap={14}>
      <VStack gap={6} w="full">
        <Reveal>
          <VStack
            gap={2}
            textAlign={{ base: "center", md: "left" }}
            w="full"
            align={{ base: "center", md: "start" }}
          >
            <Pill>Neked szól, ha…</Pill>
            <Heading
              fontSize={{ base: "xl", md: "2xl" }}
              color={TEAL_DARK}
              letterSpacing="-0.02em"
            >
              Felismered magad ezekben?
            </Heading>
          </VStack>
        </Reveal>
        <SimpleGrid columns={{ base: 1, md: 2 }} gap={3} w="full">
          {items.map((item, i) => (
            <CheckCard key={i} text={item} type="check" delay={i * 0.04} />
          ))}
        </SimpleGrid>
      </VStack>

      <Divider borderColor="gray.100" />

      <VStack gap={6} w="full">
        <Reveal>
          <VStack
            gap={2}
            textAlign={{ base: "center", md: "left" }}
            w="full"
            align={{ base: "center", md: "start" }}
          >
            <Badge
              px={3}
              py={1}
              borderRadius="full"
              bg="red.50"
              color="red.400"
              fontSize="xs"
              fontWeight={700}
              letterSpacing="wider"
              textTransform="uppercase"
            >
              Nem neked való, ha…
            </Badge>
            <Heading
              fontSize={{ base: "xl", md: "2xl" }}
              color={TEAL_DARK}
              letterSpacing="-0.02em"
            >
              Nem kell mindenkinek foglalási rendszer
            </Heading>
            <Text color="gray.500" fontSize="sm">
              Vannak, akik jobban élvezik a régi módszereket – és ez teljesen
              rendben van.
            </Text>
          </VStack>
        </Reveal>
        <SimpleGrid columns={{ base: 1, md: 2 }} gap={3} w="full">
          {excuse.map((item, i) => (
            <CheckCard key={i} text={item} type="x" delay={i * 0.04} />
          ))}
        </SimpleGrid>
      </VStack>
    </VStack>
  </Section>
);

export default ForYou;
